import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'Oracle Simphony',
  pair: 'Pair',
  unpair: 'Unpair',
  workstationId: 'Workstation ID',
})
